import { Dot, InlineLoaderWrapper, Wrapper } from './styles';
import React from 'react';

type InlineLoaderProps = {
  testId?: string;
};

export const InlineLoader: React.FC<InlineLoaderProps> = ({ testId }) => {
  return (
    <InlineLoaderWrapper data-testid={testId}>
      <Wrapper>
        <Dot />
        <Dot />
        <Dot />
      </Wrapper>
    </InlineLoaderWrapper>
  );
};
